'use client';

// Choix de la langue — français, anglais.
//
// Un POPOVER, là où un clic basculait auparavant la langue de toute l'interface sans rien
// demander : on découvrait le changement après coup. Les deux langues sont désormais visibles,
// nommées DANS LEUR PROPRE LANGUE (« Français », « English ») — c'est la convention : qui
// cherche l'anglais cherche « English », pas « Anglais ».
//
// Les drapeaux sont DESSINÉS (cf. ui/Flag) et non des emoji : sous Linux comme sous Windows,
// ces emoji n'ont aucun glyphe et s'affichent en deux lettres. Ils restent décoratifs, le nom
// portant seul l'information.

import { Flag } from '@/components/ui/Flag';
import { Menu, MenuItem } from '@/components/ui/Menu';
import { useT } from '@/hooks/useT';
import { persistLocale } from '@/i18n/config';
import { fontStyle } from '@/theme/typography';

const LANGUAGES = [
  { code: 'fr', native: 'Français' },
  { code: 'en', native: 'English' },
] as const;

export function LanguageMenu({
  triggerClassName,
}: {
  triggerClassName: string;
}) {
  const { t, i18n } = useT('common');
  const current = i18n.language === 'fr' ? 'fr' : 'en';

  const choose = (code: (typeof LANGUAGES)[number]['code']) => {
    persistLocale(code);
    void i18n.changeLanguage(code);
  };

  return (
    <Menu
      label={t('language.label')}
      width="w-48"
      triggerClassName={triggerClassName}
      trigger={
        <span className="flex items-center gap-1.5">
          <Flag code={current} />
          <span aria-hidden style={fontStyle('caption')}>
            {current.toUpperCase()}
          </span>
        </span>
      }
    >
      {LANGUAGES.map(({ code, native }) => (
        <MenuItem
          key={code}
          leading={<Flag code={code} />}
          label={native}
          selected={code === current}
          onSelect={() => choose(code)}
        />
      ))}
    </Menu>
  );
}
